import { ConcreteEncodable } from "./ConcreteEncodable";

import { ChannelFilterImplEncoder } from "../../encoder/ChannelFilterImplEncoder";

import * as CubiqTS from "../../index";
import { ChannelFilter } from "../ChannelFilter";

export class ChannelFilterImpl extends ConcreteEncodable implements ChannelFilter {
  public static enType: string = "com.bcdfx.service.messaging.impl.ChannelFilterImpl";

  /*FID=1*/
  public filter: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ChannelFilterImplEncoder.Instance;
    this.setEncodableType(ChannelFilterImpl.enType);
    //Model
  }

  public toString(): string {
    return "ChannelFilterImpl[" + "filter=" + this.filter + "messageId=" + this.messageId + "]";
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
